import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { GeneratePurchaseOrder } from '@C/Admin/GeneratePurchaseOrder';
import ErrorBoundary from '@C/Error';

class GeneratePurchaseOrderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Generate puchase order" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <GeneratePurchaseOrder />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { GeneratePurchaseOrderPage };
